<div  [ngStyle]="data.style" id="modal-container">
  <i *ngIf="data.icon" class="material-icons md-36" style="font-size: 3rem;">{{data.icon}}</i>
  <i (click)="close(null)" class="material-icons pointer" id="close">close</i>
  <h2 mat-dialog-title>{{'SERVICE.LINK_HEADER' | translate}}</h2>

  <mat-dialog-content>
    <mat-form-field>
      <mat-label class="bmd-label-floating">{{'SERVICE.LINK_DISPLAY_TEXT' | translate}}</mat-label>
      <input matInput type="text" class="form-control pointer" [formControl]="linkText">
    </mat-form-field>

    <mat-form-field>
      <mat-label class="bmd-label-floating">{{'SERVICE.LINK' | translate}}</mat-label>
      <input matInput type="text" class="form-control pointer" [formControl]="link">
    </mat-form-field>

  </mat-dialog-content>

  <mat-dialog-actions [class]="data['buttonsClass']" class="flex right">
    <button (click)="close(false)" class="home365-button primary inverted space-right">
      {{'GENERAL_TEXTS.CANCEL_BUTTON_TEXT' | translate}}
    </button>
    <button (click)="close(true)" class="home365-button primary">
      {{'GENERAL_TEXTS.SAVE_BUTTON_TEXT' | translate}}
    </button>
  </mat-dialog-actions>
</div>


